import React, { useRef, useEffect } from "react";
import { PropTypes } from "prop-types";
import { GeoMap } from "@cisco/geomaps";

export const getValidCoordinates = location => {
  const longitude = Number(location?.longitude);
  const latitude = Number(location?.latitude);

  if (
    !Number.isFinite(longitude) ||
    !Number.isFinite(latitude) ||
    longitude < -180 ||
    longitude > 180 ||
    latitude < -90 ||
    latitude > 90
  ) {
    return null;
  }

  return { longitude, latitude };
};

const GeoMapComponentMini = ({ longitude, latitude }) => {
  const coordinates = getValidCoordinates({ longitude, latitude });

  const sites = [
    {
      site_id: "1",
      site_name: "Site",
      longitude: coordinates?.longitude,
      latitude: coordinates?.latitude
    }
  ];

  const mapVisualRef = useRef(null);

  const pointsToShow = sites.map((site, index) => {
    const { site_id, site_name, longitude, latitude } = site;

    let defaultPointingOptions = {
      id: site_id,
      location: [longitude, latitude],
      name: site_name,
      defaultMarkerOptions: {
        color: "var(--hbr-color-success-border,#45991f)"
      },
      snoToShow: index + 1
    };

    return defaultPointingOptions;
  });

  const getMapSettings = () => {
    return {
      zoom: 1,
      center: [coordinates.longitude, coordinates.latitude]
    };
  };

  const createMapViual = () => {
    if (!coordinates || !mapVisualRef.current) {
      return;
    }

    let defaultInitProperties = {
      domHolder: mapVisualRef.current,
      trackResize: false,
      enableNav: false,
      enableLegend: false,
      points: pointsToShow,
      mapSettings: getMapSettings()
    };

    const map = new GeoMap(defaultInitProperties);

    map.init();
  };

  useEffect(() => {
    createMapViual();
  }, [coordinates?.longitude, coordinates?.latitude]);

  if (!coordinates) {
    return null;
  }

  return (
    <div ref={mapVisualRef} name="map-visual" className="map-visual"></div>
  );
};

GeoMapComponentMini.propTypes = {
  latitude: PropTypes.any,
  longitude: PropTypes.any
};

export default GeoMapComponentMini;
